import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center text-center p-6 gap-4" }
const _hoisted_2 = { class: "text-2xl font-semibold mb-3" }
const _hoisted_3 = { class: "text-sm" }
const _hoisted_4 = {
  key: 0,
  class: "w-full flex justify-center mb-6"
}
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputPhone = _resolveComponent("InputPhone")!
  const _component_PopUpLight = _resolveComponent("PopUpLight")!
  const _directive_disable_on_click = _resolveDirective("disable-on-click")!

  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      (_ctx.open)
        ? (_openBlock(), _createBlock(_component_PopUpLight, {
            key: 0,
            onClosed: _ctx.emitClose
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.sendOk
              ? _ctx.$t("send_ok_title")
              : _ctx.hasPhone
                ? _ctx.$t("verify_phone_title")
                : _ctx.$t("add_phone_title")), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.sendOk
              ? _ctx.$t("send_ok_description")
              : _ctx.hasPhone
                ? _ctx.$t("verify_phone_description")
                : _ctx.$t("add_phone_description")), 1),
                (!_ctx.sendOk)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_InputPhone, {
                        initialPhone: _ctx.initialPhone,
                        initialPrefix: _ctx.initialPrefix,
                        onPhoneValidated: _ctx.handlePhoneValidated
                      }, null, 8, ["initialPhone", "initialPrefix", "onPhoneValidated"])
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  disabled: _ctx.isDisabled,
                  class: _normalizeClass([{ forceDisabled: _ctx.isDisabled }, "w-full max-w-xs h-12 search-btn sm:flex sm:justify-center sm:items-center"]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.verifyPhone()))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.sendOk
              ? _ctx.$t("send_ok_button")
              : _ctx.hasPhone
                ? _ctx.$t("verify_phone_button")
                : _ctx.$t("add_phone_button")), 1)
                ], 10, _hoisted_5)), [
                  [_directive_disable_on_click, void 0, "verify-phone"]
                ]),
                (!_ctx.sendOk)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "w-full max-w-xs h-12 search-btn sm:flex sm:justify-center sm:items-center",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.anotherTime()))
                    }, _toDisplayString(_ctx.$t("another_time")), 1))
                  : _createCommentVNode("", true),
                (!_ctx.sendOk && _ctx.showRemain)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      href: "#",
                      class: "text-sm text-[#0458E2] no-underline",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.notRemind()), ["prevent"]))
                    }, _toDisplayString(_ctx.$t("not_remind")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["onClosed"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}